import { render, staticRenderFns } from "./DonationModalFull.vue?vue&type=template&id=4b8101d0&"
import script from "./DonationModalFull.vue?vue&type=script&lang=js&"
export * from "./DonationModalFull.vue?vue&type=script&lang=js&"
import style0 from "./DonationModalFull.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
